jQuery(document).ready(function ($) {
  $(".account-navigation-mobile-toggle").click(function () {
    $(this).toggleClass("open");
    $(".woocommerce-MyAccount-navigation").slideToggle("slow");
  });
});
